import * as React from 'react'
import type {SVGProps} from 'react'
const SvgBrandLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={44}
        height={42}
        fill="none"
        viewBox="0 0 46 32"
        {...props}
    >
        <path
            fill="#0D9DDA"
            d="M1 1.943a1 1 0 0 1 1.581-.814l40 28.572a1 1 0 0 1 .419.814v9.542a1 1 0 0 1-1.581.813l-40-28.57A1 1 0 0 1 1 11.484z"
        />
        <path
            fill="#8ECAE3"
            d="M22 1.943a1 1 0 0 1 1.581-.814l19 13.572a1 1 0 0 1 .419.814v9.542a1 1 0 0 1-1.581.814l-19-13.572a1 1 0 0 1-.419-.814z"
        />
        <path
            fill="#0B5473"
            d="M1 16.943a1 1 0 0 1 1.581-.814l19 13.572a1 1 0 0 1 .419.814v9.542a1 1 0 0 1-1.581.813l-19-13.57A1 1 0 0 1 1 26.484z"
        />
    </svg>
)
export default SvgBrandLogo
